"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStep = exports.PaymentPurpose = exports.PaymentGateway = exports.PaymentStatus = exports.PaymentType = void 0;
var PaymentType;
(function (PaymentType) {
    PaymentType["Cash"] = "Cash";
    PaymentType["Electronic"] = "Electronic";
    PaymentType["Wallet"] = "Wallet";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Abandoned"] = "abandoned";
    PaymentStatus["Failed"] = "failed";
    PaymentStatus["Ongoing"] = "ongoing";
    PaymentStatus["Pending"] = "pending";
    PaymentStatus["Processing"] = "processing";
    PaymentStatus["Queued"] = "queued";
    PaymentStatus["Reversed"] = "reversed";
    PaymentStatus["Success"] = "success";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var PaymentGateway;
(function (PaymentGateway) {
    PaymentGateway["PayStack"] = "PayStack";
    PaymentGateway["Wallet"] = "Wallet";
    PaymentGateway["KudaBank"] = "KudaBank";
})(PaymentGateway || (exports.PaymentGateway = PaymentGateway = {}));
var PaymentPurpose;
(function (PaymentPurpose) {
    // Order = "Order",
    // Wallet = "Wallet",
    PaymentPurpose["FundWallet"] = "FundWallet";
    PaymentPurpose["OrderPayment"] = "OrderPayment";
    PaymentPurpose["FundVirtualAccount"] = "FundVirtualAccount";
    PaymentPurpose["NotDefined"] = "NotDefined";
})(PaymentPurpose || (exports.PaymentPurpose = PaymentPurpose = {}));
var PaymentStep;
(function (PaymentStep) {
    PaymentStep["Initialize"] = "Initialize";
    PaymentStep["StartUpdate"] = "StartUpdating";
    PaymentStep["AddWalletTransactions"] = "AddWalletTransactions";
    PaymentStep["GetWalletAccount"] = "GetWalletAccount";
    PaymentStep["UpdatedWalletAccount"] = "UpdatedWalletAccount";
    PaymentStep["GetVirtualAccount"] = "GetVirtualAccount";
    PaymentStep["AddVirtualAccountTransactions"] = "AddVirtualAccountTransactions";
    PaymentStep["UpdateVirtualAccount"] = "UpdateVirtualAccount";
    PaymentStep["GetPayment"] = "GetPayment";
    PaymentStep["UpdatePayment"] = "UpdatePayment";
    PaymentStep["GetOrder"] = "GetOrder";
    PaymentStep["UpdateOrder"] = "UpdateOrder";
    PaymentStep["AllDDbUpdated"] = "AllDDbUpdated";
})(PaymentStep || (exports.PaymentStep = PaymentStep = {}));
//# sourceMappingURL=payment.js.map